import { HiPlus } from "react-icons/hi";
import CorrespondantLookup from "../CorrespondantLookup";
import { Field, FieldGrid } from "./FormField";
import { TERMINAL_ADMISSION_STATUSES } from "../../utils";

const CorrespondantsSection = ({ admission, autocompleteSettings, onAdmissionChange, ProcessingStatusIcon }) => {
  const isLocked = TERMINAL_ADMISSION_STATUSES.includes(admission?.status);
  const correspondants = (admission?.correspondants || []).filter((correspondant) => !isLocked || correspondant?.code || correspondant?.name);

  if (isLocked && correspondants.length === 0) return null;

  return (
    <div className="mb-4">
      <h3 className="section-title mb-2">
        <span>Correspondants</span>
      </h3>
      <div className="card px-4 py-3">
        {correspondants.length > 0 && (
          <FieldGrid>
            {correspondants.map((correspondant, index) => (
              <Field key={`correspondant-${index}`} label={`Correspondant ${index + 1}`} span={12}>
                <CorrespondantLookup
                  placeholder="Rechercher un correspondant..."
                  initialCorrespondant={correspondant}
                  onCorrespondantSelect={(nextCorrespondant) => {
                    const updatedCorrespondants = correspondants.map((existingCorrespondant, correspondantIndex) =>
                      correspondantIndex === index ? nextCorrespondant : existingCorrespondant,
                    );
                    onAdmissionChange([{ field: "correspondants", value: updatedCorrespondants }]);
                  }}
                  onCorrespondantRemove={() => {
                    const updatedCorrespondants = correspondants.filter((_, correspondantIndex) => correspondantIndex !== index);
                    onAdmissionChange([{ field: "correspondants", value: updatedCorrespondants }]);
                  }}
                  autocompleteEnabled={autocompleteSettings.doctor}
                  removable
                  disabled={isLocked}
                  icon={<ProcessingStatusIcon type="CORRESPONDANT" referenceId={correspondant._id} />}
                />
              </Field>
            ))}
          </FieldGrid>
        )}
        {!isLocked && (
          <div className={correspondants.length > 0 ? "mt-2" : ""}>
            {autocompleteSettings.doctor === true ? (
              <CorrespondantLookup
                onCorrespondantSelect={(nextCorrespondant) =>
                  onAdmissionChange([{ field: "correspondants", value: [...correspondants, nextCorrespondant] }])
                }
                searchBarOnly={true}
                placeholder="Ajouter un correspondant..."
                autocompleteEnabled={autocompleteSettings.doctor}
              />
            ) : (
              <button
                type="button"
                className="flex w-full items-center justify-center gap-2 rounded-md border border-dashed border-gray-300 bg-transparent px-3 py-2 text-xs text-gray-500 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-600"
                onClick={() => onAdmissionChange([{ field: "correspondants", value: [...correspondants, {}] }])}
              >
                <HiPlus className="h-3.5 w-3.5" />
                Ajouter un correspondant
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CorrespondantsSection;
